<template>
  <div class="opacity-0">
    <UserProperty
      @dataAvailable="
        data => {
          userData = data
        }
      "
      isComponent
    />
    <AppDataProperty
      contentId="addresses"
      @dataAvailable="
        data => {
          appData = data
        }
      "
      isComponent
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import UserProperty from '../user/UserProperty.vue'
import AppDataProperty from '../appData/AppDataProperty.vue'

export default defineComponent({
  name: 'Chat',
  components: { UserProperty, AppDataProperty },
  props: {},
  data() {
    return {
      eventsIds: [],
      userData: {},
      appData: {},
    }
  },
  mounted() {
    const id = this.$Events.handleEvent('logout_done', this.disconnectUser)
    const id2 = this.$Events.handleEvent(
      'user_preferences_updated',
      this.updateChatData,
    )
    const id3 = this.$Events.handleEvent('open_chat', this.openChat)
    const id4 = this.$Events.handleEvent('close_chat', this.closeChat)
    const id5 = this.$Events.handleEvent('on_chat_closed', this.onChatClosed)
    const id6 = this.$Events.handleEvent('on_chat_opened', this.onChatOpened)

    this.eventsIds.push(id)
    this.eventsIds.push(id2)
    this.eventsIds.push(id3)
    this.eventsIds.push(id4)
    this.eventsIds.push(id5)
    this.eventsIds.push(id6)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    disconnectUser() {
      this.$Chat.disconnectUser()
    },
    async updateChatData() {
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      this.$Chat.setUserData(this.userData, this.appData, userPreferences)
    },
    async openChat() {
      this.$Chat.openChat()
      this.$router.push({ hash: '#chat' }).catch(e => {})
      const networkState =
        await this.$Events.sendDataRequestResolve('networkState')
      if (!networkState?.networkAvailable) {
        if (!this.$Chat.isOpened()) this.closeChat()
        this.$Events.dispatchEvent('toast_notification', {
          type: 'warning',
          title: this.$t('chat.badNetworkTitle'),
          body: this.$t('chat.badNetworkTitle'),
        })
      }
    },
    closeChat() {
      this.$Chat.closeChat()
      if (this.$route.hash === '#chat') this.$router.back()
    },
    isOpened() {
      return this.$Chat.isOpened()
    },
    onChatClosed() {
      if (this.$route.hash === '#chat') this.$router.back()
    },
    onChatOpened() {
      this.$router.push({ hash: '#chat' }).catch(e => {})
    },
  },
  computed: {},
  watch: {
    userData: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (!newValue.reference) {
          // this.$Chat.disconnectUser();
          return
        }
        this.updateChatData()
      },
    },
    appData: {
      deep: true,
      handler() {
        if (!this.userData.reference) return
        this.updateChatData()
      },
    },
    $route: {
      deep: true,
      handler(newRoute) {
        if (!this.isOpened()) return
        const hash = newRoute.hash
        if (hash === '#chat') return
        this.closeChat()
      },
    },
  },
})
</script>

<style>
.woot-widget-bubble {
  display: none !important;
}

.woot-widget-holder {
  max-height: calc(100% + 25px) !important;
  height: calc(100% + 25px) !important;
  margin-bottom: -25px !important;
  z-index: 99 !important;
}
</style>
